// test2417
(2417 && 0);
